/** LIKS entity fields used for optimistic locking on user updates. */
export type UserOptimisticLockFields = {
  id?: string | null;
  version?: number | null;
  stamp?: string | null;
  created?: string | null;
};

export function pickUserOptimisticLockFields(
  source: UserOptimisticLockFields,
): UserOptimisticLockFields {
  const result: UserOptimisticLockFields = {};

  const id = source.id?.trim();
  if (id) {
    result.id = id;
  }

  if (source.version != null) {
    result.version = source.version;
  }

  const stamp = source.stamp?.trim();
  if (stamp) {
    result.stamp = stamp;
  }

  const created = source.created?.trim();
  if (created) {
    result.created = created;
  }

  return result;
}

/** Include `enabled` only when the caller intends to change account status. */
export function pickUserEnabledField(
  enabled: boolean | null | undefined,
): { enabled: boolean } | Record<string, never> {
  return typeof enabled === 'boolean' ? { enabled } : {};
}
